<div class="bottom-sheet-data-wrapper">
    <span class="ms-5 me-5 delete-confirmation"><span class="ms-5">Click proceed to send an email to the tenants requesting to update the property’s asset details</span></span>
    <button (click)="sentToTenantAsset()" class="common-button success mat-elevation-z0 mx-1" mat-button mat-raised-button [class.spinner]="isLoading" [disabled]="isLoading">
        Proceed
    </button>
    <button (click)="cancel()" class="common-button black mat-elevation-z0 mx-1" mat-button mat-raised-button [disabled]="isLoading">
        Cancel
    </button>
</div>